
import { defineComponent } from 'vue';
import { AppInput, AppButton } from '@/components';
import { useVerify } from '@/modules/login/model/verify';

export default defineComponent({
    name: 'LoginVerify',
    components: { AppInput, AppButton },

    setup() {
        const { model, v$, verify } = useVerify();

        return { v$, model, verify };
    }
});
